import { ReactNode } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';

const queryClient = new QueryClient();

export const MountedQueryClientProvider = ({
    children,
}: {
    children: ReactNode;
}): JSX.Element => (
    <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
);

export { useQueryClient } from 'react-query';
